"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LookupTable = /*#__PURE__*/function () {
  function LookupTable() {
    _classCallCheck(this, LookupTable);

    _defineProperty(this, "data", {});
  }

  _createClass(LookupTable, [{
    key: "clear",
    value: function clear() {
      this.data = {};
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.data[key];
    }
  }, {
    key: "has",
    value: function has(key) {
      return this.data[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.data[key] = value;
      return value;
    }
  }, {
    key: "unset",
    value: function unset(key) {
      if (this.data[key] !== undefined) {
        delete this.data[key];
      }
    }
  }]);

  return LookupTable;
}();

var _default = LookupTable;
exports["default"] = _default;